import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { api } from 'app';
import Field from './FieldContainer';
import Spinner from './Spinner';
import TinyMCE from './LazyTinyMCE';

const editorHeight = 250;
const placeholderHeight = 291;

const PlaceholderWrapper = styled('div')`
  align-items: center;
  display: flex;
  height: ${placeholderHeight}px;
  justify-content: center;
`;

const Wrapper = styled('div')`
  border: 1px solid #ddd;
  border-radius: 3px;
  min-height: ${placeholderHeight}px;
  width: 100%;

  .mce-tinymce {
    border: none;
    box-shadow: none !important;
  }

  .mce-top-part:before {
    box-shadow: none !important;
  }

  .mce-edit-area {
    border-color: #eee;
  }
`;

const config = {
  allow_conditional_comments: false,
  content_css: ['/tinymce/content.css'],
  directionality: 'rtl',
  paste_as_text: true,
  font_formats:
    "Default='IRANSans', Arial, Helvetica, Tahoma, Verdana, sans-serif;Arial=helvetica,sans-serif",
  height: editorHeight,
  image_advtab: false,
  images_upload_handler: (blobInfo, success, failure) => {
    api
      .post('/images', { file: blobInfo.blob() }, { type: 'formData' })
      .then(response => response.json())
      .then(response => {
        success(`${response.location}?x-oss-process=image/resize,w_600`);
      })
      .catch(error => {
        failure('Upload failed!');
      });
  },
  language: 'fa_IR',
  language_url: '/tinymce/langs/fa_IR.js',
  media_alt_source: false,
  media_poster: false,
  menubar: false,
  oninit: 'setPlainText',
  paste_data_images: false,
  plugins: 'code lists advlist link image media',
  statusbar: false,
  toolbar:
    'undo redo | bold italic underline | alignleft aligncenter alignright alignjustify | numlist bullist | image link | code| removeformat',
  urlconverter_callback: (url, node, on_save, name) => {
    if (name === 'href') {
      return url.match(/^[a-zA-Z]+:\/\//) ? url : `http://${url}`;
    } else {
      return url;
    }
  },
  toolbar_items_size: 'small',
  valid_classes: 'panel'
};

function Placeholder() {
  return (
    <PlaceholderWrapper>
      <Spinner />
    </PlaceholderWrapper>
  );
}

function RichTextField({ onEditorChange, value, ...rest }) {
  const id = parseInt(Math.random() * 10);

  const handleEditorChange = e => {
    if (onEditorChange) {
      onEditorChange(e);
    }
  };

  return (
    <Field {...rest}>
      <Wrapper>
        <Suspense fallback={<Placeholder />}>
          <TinyMCE
            apiKey="wgziir2wqhk0058cffu7gurqanuega5joohlgcm1v3ze5bmc"
            id={`tinymce-${id}`}
            value={value}
            init={config}
            onEditorChange={handleEditorChange}
          />
        </Suspense>
      </Wrapper>
    </Field>
  );
}

RichTextField.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string
};

export default RichTextField;
